import React from "react";
import { SbButton } from "uiCore";
import { PAIC_VIEW_MODES } from "constants/peoplePlusAI.constants";
import CoreMarkdownEditor from "Components/SbMarkdownEditor/CoreMarkdownEditor";
import {
  EditShell,
  EditHeader,
  EditHeaderText,
  EditActions,
  EditTitle,
  EditDescription,
  EditBody,
} from "Pages/PeoplePlusAIV2/shared/DocumentView.styles";

/**
 * Shared document edit panel component for all PAIC document views
 * Replaces: PACJdPrdEditPanelV2, PACJdViewEditPanelV2, PACPeopleJDEditPanelV2
 */
const SbPACDocumentEditPanelV2 = ({
  content,
  contentKey,
  onChange,
  onCancel,
  onSubmit,
  submitting = false,
  submitText = "Submit",
  submitDisabled = false,
  title = "Editing Draft",
  description = "Prepare your draft and assign an approver to submit.",
}) => {
  return (
    <EditShell>
      <EditHeader>
        <EditHeaderText>
          <EditTitle>{title}</EditTitle>
          <EditDescription>{description}</EditDescription>
        </EditHeaderText>

        <EditActions>
          <SbButton onClick={onCancel}>Cancel</SbButton>
          <SbButton
            buttonType="primary"
            loading={submitting}
            disabled={submitDisabled}
            onClick={onSubmit}
          >
            {submitText}
          </SbButton>
        </EditActions>
      </EditHeader>

      <EditBody>
        <div id="content-to-download">
          <CoreMarkdownEditor
            key={contentKey}
            initialMarkdown={content}
            onChange={onChange}
            viewMode={PAIC_VIEW_MODES.EDIT}
          />
        </div>
      </EditBody>
    </EditShell>
  );
};

export default SbPACDocumentEditPanelV2;
